import { IAttendeeModel } from '@shared/models/attendee.model';
import { SortedPage } from '@shared/models/sortedPage';

export interface IUtmTrackings {
    utmTrackings: IUtmTracking[];
}

export class UtmTrackings implements IUtmTrackings {
    constructor(
        public utmTrackings: IUtmTracking[]
    ) { }
}

export interface IUtmTracking {
    attendee: IAttendeeModel;
    utmData: IUtmData;
}

export class UtmTracking implements IUtmTracking {
    constructor(
        public attendee: IAttendeeModel,
        public utmData: IUtmData
    ) { }
}

export interface IUtmData {
    medium: string;
    source: string;
    campaign: string;
    term: string;
    content: string;
    campaignId: string;
}

export class UtmData implements IUtmData {
    constructor(
        public medium: string,
        public source: string,
        public campaign: string,
        public term: string,
        public content: string,
        public campaignId: string
    ) { }
}

export interface IUtmStatistics {
    mediumCounts: object;
    sourceCounts: object;
    campaignCounts: object;
    termCounts: object;
    contentCounts: object;
    campaignIdCounts: object;
}

export class UtmStatistics implements IUtmStatistics {
    constructor(
        public mediumCounts: object,
        public sourceCounts: object,
        public campaignCounts: object,
        public termCounts: object,
        public contentCounts: object,
        public campaignIdCounts: object
    ) { }
}

export interface IUtmStatistic {
    key: string;
    value: number;
}

export class UtmStatistic implements IUtmStatistic {
    constructor(
        public key: string,
        public value: number
    ) { }
}

export class UtmTrackingsFilterModel {
    public searchValue = '';
    public locationDateTimeFilter: string = null;
    public ticketHolderFilter: string = null;
    public accountOwnerFilter: string = null;
    public medium: string = null;
    public source: string = null;
    public campaign: string = null;
    public term: string = null;
    public content: string = null;
    public campaingId: string = null;
}

export class UtmTrackingsPage extends SortedPage {
    public eventId: string;
    public filterModel: UtmTrackingsFilterModel = new UtmTrackingsFilterModel();
}

export class UtmTrackingsPagedData<T> extends UtmTrackingsPage {
    public utmTrackings = new Array<T>();
}

export interface IUtmTrackingsRequest {
    eventId: string;
    filterModel: UtmTrackingsFilterModel;
}

export class UtmTrackingsRequest implements IUtmTrackingsRequest {
    constructor(
        public eventId: string,
        public filterModel: UtmTrackingsFilterModel,
        public sortProperty?: string,
        public sortDirection?: string,
        public languageId?: string
    ) { }
}
